import { NodeService } from "../../services/models/node";
const moduleNode = {
  namespaced: true,
  state: {
    nodes: [],
    loading: false,
  },
  getters: {
    getNodes(state) {
      return state.nodes;
    },
    //Se hizo para ocultar ciertos destinos al crear interconsulta en el componente CreateIcSchedule
    getNodesForIc(state) {
      return state.nodes.filter((node) => node.id != 26 && node.id != 2730 && node.id != 2961 && node.id != 3408 && node.id != 5050);
    },
    getLoading(state) {
      return state.loading;
    },
  },
  mutations: {
    loadNodes(state, nodes) {
      state.nodes = nodes;
    },
  },
  actions: {
    async loadNodes({ commit, state }) {
      state.loading = true;
      let nodes = await NodeService.getAll();
      commit("loadNodes", nodes);
      state.loading = false;
    },
  },
};

export default moduleNode;
